/* eslint-disable import/prefer-default-export */
/* eslint-disable class-methods-use-this */
import IBase from './base';

// 按钮点击埋点
class ICK extends IBase {
  // 门店列表_致电
  门店列表_致电() {
    this.ck({
      android: {
        pageId: 'Android_换电_门店列表',
        buttonName: 'switchpower_115',
      },
      ios: {
        pageId: 'IOS_换电_门店列表',
        buttonName: 'switchpower_zhidian5',
      },
      alipay: {
        pageId: 'Alipay_换电_门店列表页',
        buttonName: 'switchpower_mendianliebzhidian',
      },
    });
  }

  // 门店列表_导航
  门店列表_导航({ shopId }) {
    this.ck({
      android: {
        pageId: 'Android_换电_门店列表页',
        buttonName: 'switchpower_116',
      },
      ios: {
        pageId: 'IOS_换电_门店列表页',
        buttonName: 'switchpower_daohang7',
      },
      alipay: {
        pageId: 'Alipay_换电_门店列表页',
        buttonName: 'switchpower_mendianliebiaodaohang',
      },
    }, {
      shopid: shopId,
    });
  }

  // 个人中心_个人资料
  个人中心_个人资料() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_117',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_gerenziliao1',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_gerenziliao',
      },
    });
  }

  // 个人中心_购买记录
  个人中心_购买记录() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_118',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_jilu',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_goumaijilu',
      },
    });
  }

  // 个人中心_套餐
  个人中心_套餐() {
    // 套餐不可点击，暂无此埋点
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_119',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_can',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_taocan',
      },
    });
  }

  // 个人中心_押金
  个人中心_押金() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_120',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_yajin2',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_yajin',
      },
    });
  }

  // 押金页_购买套餐
  押金页_购买套餐(packagesStatus) {
    this.ck({
      android: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_topurchasegood',
      },
      ios: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_topurchasegood',
      },
      alipay: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_topurchasegood',
      },
    }, {
      packagesStatus,
    });
  }

  // 押金页_交押金
  押金页_交押金(packagesStatus) {
    this.ck({
      android: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_pay_deposit',
      },
      ios: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_pay_deposit',
      },
      alipay: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_pay_deposit',
      },
    }, {
      packagesStatus,
    });
  }

  // 押金页_退款
  押金页_退款(packagesStatus) {
    this.ck({
      android: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_refund_deposit',
      },
      ios: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_refund_deposit',
      },
      alipay: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_refund_deposit',
      },
    }, {
      packagesStatus,
    });
  }

  // 押金页_退款确认
  押金页_退款确认(packagesStatus) {
    this.ck({
      android: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_refund_deposit_confirm',
      },
      ios: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_refund_deposit_confirm',
      },
      alipay: {
        pageId: 'switchpower_mydeposit',
        buttonName: 'switchpower_refund_deposit_confirm',
      },
    }, {
      packagesStatus,
    });
  }

  // 订单详情_交押金
  订单详情_交押金() {
    this.ck({
      android: {
        pageId: 'switchpower_orderdetails',
        buttonName: 'switchpower_topaythedeposit',
      },
      ios: {
        pageId: 'switchpower_orderdetails',
        buttonName: 'switchpower_topaythedeposit',
      },
      alipay: {
        pageId: 'switchpower_orderdetails',
        buttonName: 'switchpower_topaythedeposit',
      },
    });
  }

  // 个人中心_交押金按钮
  个人中心_交押金按钮() {
    this.ck({
      android: {
        pageId: 'switchpower_mycenter',
        buttonName: 'switchpower_topaythedeposit',
      },
      ios: {
        pageId: 'switchpower_mycenter',
        buttonName: 'switchpower_topaythedeposit',
      },
      alipay: {
        pageId: 'switchpower_mycenter',
        buttonName: 'switchpower_topaythedeposit',
      },
    });
  }

  // 个人中心_续购按钮
  个人中心_续购按钮() {
    this.ck({
      android: {
        pageId: 'switchpower_mycenter',
        buttonName: 'switchpower_topurchasegood',
      },
      ios: {
        pageId: 'switchpower_mycenter',
        buttonName: 'switchpower_topurchasegood',
      },
      alipay: {
        pageId: 'switchpower_mycenter',
        buttonName: 'switchpower_topurchasegood',
      },
    });
  }


  // 个人中心_优惠券
  个人中心_优惠券() {
    this.ck({
      android: {}, // 遗漏
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_youhuiquan3',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_youhuiquan',
      },
    });
  }

  // 个人中心_我的电池
  个人中心_我的电池() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_122',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_44',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_wodediancji',
      },
    });
  }

  // 个人中心_我的车辆
  个人中心_我的车辆() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_122',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_45',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_wodecheliang',
      },
    });
  }

  // 个人中心_我的保险
  个人中心_我的保险() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_124',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_46',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_wdebaoxian',
      },
    });
  }

  // 个人中心_换电记录
  个人中心_换电记录() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_125',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_47',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_huandianjilu',
      },
    });
  }

  // 个人中心_卡券兑换
  个人中心_卡券兑换() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_126',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_48',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_kaquanduihuan',
      },
    });
  }

  // 个人中心_扫渠道码
  个人中心_扫渠道码() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_127',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_49',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_saoqudaoma',
      },
    });
  }

  // 个人中心_客服电话
  个人中心_客服电话() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_128',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_50',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_1kefudianhua',
      },
    });
  }

  // 个人中心_购买按钮
  个人中心_购买按钮() {
    this.ck({
      android: {
        pageId: 'Android_换电_个人中心',
        buttonName: 'switchpower_129',
      },
      ios: {
        pageId: 'IOS_换电_个人中心',
        buttonName: 'switchpower_51',
      },
      alipay: {
        pageId: 'Alipay_换电_个人中心',
        buttonName: 'switchpower_goumaianniu',
      },
    });
  }

  // 我的优惠券_去使用
  我的优惠券_去使用() {
    this.ck({
      android: {
        pageId: 'Android_换电_我的优惠券',
        buttonName: 'switchpower_130',
      },
      ios: {
        pageId: 'IOS_换电_我的优惠券',
        buttonName: 'switchpower_61',
      },
      alipay: {
        pageId: 'Alipay_换电_我的优惠券（最新）',
        buttonName: 'switchpower_wdeyouhuiquan',
      },
    });
  }

  // 我的资料_协议点击
  我的资料_协议点击() {
    this.ck({
      android: {}, // 遗漏
      ios: {}, // 遗漏
      alipay: {
        pageId: 'Alipay_换电_我的资料',
        buttonName: 'switchpower_xieyidianji',
      },
    });
  }

  // 购买套餐_套餐详情
  购买套餐_套餐详情() {
    this.ck({
      pageId: 'switchpower_goodslist',
      buttonName: 'switchpower_goodsdetail',
    });
  }

  // 购买套餐_套餐TAB切换
  购买套餐_套餐TAB切换() {
    this.ck({
      pageId: 'switchpower_goodslist',
      buttonName: 'switchpower_switchtab',
    });
  }

  // 购买套餐_优惠券
  购买套餐_优惠券() {
    this.ck({
      pageId: 'switchpower_goodslist',
      buttonName: 'switchpower_coupon',
    });
  }

  // 购买套餐_去支付
  购买套餐_去支付() {
    this.ck({
      pageId: 'switchpower_goodslist',
      buttonName: 'switchpower_topay',
    });
  }

  // 卡券兑换页_确认兑换
  卡券兑换页_确认兑换() {
    this.ck({
      android: {
        pageId: 'Android_换电_卡券兑换',
        buttonName: 'switchpower_151',
      },
      ios: {
        pageId: 'IOS_换电_卡券兑换',
        buttonName: 'switchpower_70',
      },
      alipay: {
        pageId: 'Alipay_换电_卡券兑换',
        buttonName: 'switchpower_1kaquanduihuan',
      },
    });
  }

  // 购买记录_弹窗点击联系客服
  购买记录_弹窗点击联系客服(orderId) {
    this.ck({
      pageId: 'switchpower_payment_history',
      buttonName: 'switchpower_contactcustomservice',
    }, { orderId });
  }

  // 购买记录_归还电池弹窗点击知道了
  购买记录_归还电池弹窗点击知道了(orderId) {
    this.ck({
      pageId: 'switchpower_payment_history',
      buttonName: 'switchpower_returnbattery',
    }, { orderId });
  }

  // 购买记录_联系商家弹窗点击知道了
  购买记录_联系商家弹窗点击知道了(orderId) {
    this.ck({
      pageId: 'switchpower_payment_history',
      buttonName: 'switchpower_contactmerchant',
    }, { orderId });
  }

  // 购买记录_点击退款
  购买记录_点击退款(orderId) {
    this.ck({
      pageId: 'switchpower_payment_history',
      buttonName: 'switchpower_refund',
    }, { orderId });
  }

  // 购买记录_点击订单二维码
  购买记录_点击订单二维码(orderId) {
    this.ck({
      pageId: 'switchpower_payment_history',
      buttonName: 'switchpower_orderQRcode',
    }, { orderId });
  }

  // 购买记录_退款申请页点击退款金额问号
  购买记录_退款申请页点击退款金额问号() {
    this.ck({
      pageId: 'switchpower_refundpage',
      buttonName: 'switchpower_refundrulehelp',
    });
  }

  // 购买记录_退款申请页点击退款原因选项
  购买记录_退款申请页点击退款原因选项(orderId, refundReason) {
    this.ck({
      pageId: 'switchpower_refundpage',
      buttonName: 'switchpower_refundreason',
    }, { orderId, refundReason });
  }

  // 购买记录_退款申请页取消退款
  购买记录_退款申请页取消退款(orderId) {
    this.ck({
      pageId: 'switchpower_refundpage',
      buttonName: 'switchpower_refund_cancel',
    }, { orderId });
  }

  // 购买记录_退款申请页提交退款
  购买记录_退款申请页提交退款(orderId) {
    this.ck({
      pageId: 'switchpower_refundpage',
      buttonName: 'switchpower_refund_submit',
    }, { orderId });
  }

  // 购买记录_点击订单进入详情页
  购买记录_点击订单进入详情页(orderId) {
    this.ck({
      pageId: 'switchpower_payment_history',
      buttonName: 'switchpower_orderdetails_click',
    }, { orderId });
  }

  // 购买记录_订单详情页_点击二维码
  购买记录_订单详情页_点击二维码(orderId) {
    this.ck({
      pageId: 'switchpower_orderdetails',
      buttonName: 'switchpower_orderQRcode',
    }, { orderId });
  }

  // 购买记录_订单详情页_点击退款
  购买记录_订单详情页_点击退款(orderId) {
    this.ck({
      pageId: 'switchpower_orderdetails',
      buttonName: 'switchpower_refund',
    }, { orderId });
  }

  // 购买记录_订单详情页_复制订单编号
  购买记录_订单详情页_复制订单编号(orderId) {
    this.ck({
      pageId: 'switchpower_orderdetails',
      buttonName: 'switchpower_copyorderid',
    }, { orderId });
  }

  // 购买记录_订单详情页_弹窗点击联系客服
  购买记录_订单详情页_弹窗点击联系客服(orderId) {
    this.ck({
      pageId: 'switchpower_orderdetails',
      buttonName: 'switchpower_contactcustomservice',
    }, { orderId });
  }

  // 购买记录_订单详情页_归还电池弹窗点击知道了
  购买记录_订单详情页_归还电池弹窗点击知道了(orderId) {
    this.ck({
      pageId: 'switchpower_orderdetails',
      buttonName: 'switchpower_returnbattery',
    }, { orderId });
  }

  // 购买记录_订单详情页_联系商家弹窗点击知道了
  购买记录_订单详情页_联系商家弹窗点击知道了(orderId) {
    this.ck({
      pageId: 'switchpower_orderdetails',
      buttonName: 'switchpower_contactmerchant',
    }, { orderId });
  }

  // 换电浏览器打开引导弹窗点击复制链接
  copyPathLinkToBrowser() {
    this.ck({
      pageId: 'switchpower_goodslist',
      buttonName: 'switchpower_copylinktobrowser',
    });
  }

  // 邀请明细-全部
  invitingDetailTotal() {
    this.ck({
      pageId: 'switchpower_inviting_detail',
      buttonName: 'switchpower_inviting_detail_total',
    });
  }

  // 邀请明细-待发放
  invitingDetailTodomoney() {
    this.ck({
      pageId: 'switchpower_inviting_detail',
      buttonName: 'switchpower_inviting_detail_todomoney',
    });
  }

  // 邀请明细-在途中
  invitingDetailIngmoney() {
    this.ck({
      pageId: 'switchpower_inviting_detail',
      buttonName: 'switchpower_inviting_detail_ingmoney',
    });
  }

  // 邀请明细-在途中
  invitingDetailDonemoney() {
    this.ck({
      pageId: 'switchpower_inviting_detail',
      buttonName: 'switchpower_inviting_detail_donemoney',
    });
  }

  // ------ 卡卷-----//

  // 车服H5活动页开卡按钮模块点击
  switchpowerH5Open(source = '') {
    this.ck({
      pageId: 'station_H5',
      buttonName: 'switchpower_H5_open',
    }, {
      source,
    });
  }

  // 开卡后返回首页按钮模块点击
  stationH5ActivatReturn(source = '') {
    this.ck({
      pageId: 'station_H5_activate',
      buttonName: 'station_H5_activat_return',
    }, {
      source,
    });
  }
  // ------ 卡卷 end-----//
}

export const CK = new ICK();
